import { render, staticRenderFns } from "./OtherIdsPanel.vue?vue&type=template&id=4c252749"
import script from "./OtherIdsPanel.vue?vue&type=script&lang=js"
export * from "./OtherIdsPanel.vue?vue&type=script&lang=js"
import style0 from "./OtherIdsPanel.vue?vue&type=style&index=0&id=4c252749&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports